import { render, staticRenderFns } from "./ListAdmin.vue?vue&type=template&id=607f611a&scoped=true"
import script from "./ListAdmin.vue?vue&type=script&lang=js"
export * from "./ListAdmin.vue?vue&type=script&lang=js"
import style0 from "./ListAdmin.vue?vue&type=style&index=0&id=607f611a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607f611a",
  null
  
)

export default component.exports